/**
 * Handles the JavaScript associated with sidebar components
 */

class Sidebar {
	constructor() {

		// Constants that won't change
		const timer = document.querySelectorAll( '.sidebar-component-countdown-clock' );
		const timerCount = timer.length;

		// Caching some variables
		var timeinterval;
		var jsMsgHook;
		var endtime;
		var clock;
		var i;
		var browser=navigator.userAgent.toLowerCase();

		// If there are timers on this page
		if ( timerCount ) {

			// Loop though them
			for ( i = 0; i < timerCount; i = i + 1 ) {

				// Get the timer instance
				clock = timer[i];

				// Get the message instance
				jsMsgHook = clock.querySelector( '.sidebar-message' );

				// Get the Endtime
				endtime = clock.querySelector( '.sidebar-timer__wrap' ).getAttribute( 'data-endtime' );

				// Run the function once to avoid a delayed start
				updateClock( clock, endtime );

				// Set up the time interval to tick the clock down
				executeInterval( clock, endtime );

			} // for

		} // timerCount

		// Pulling this out of the loop
		function executeInterval( clock, endtime ) {

			timeinterval = setInterval( function ( ) {

				// Update the clock every second
				updateClock( clock, endtime );

			}, 1000 );

		} // executeInterval()

		// Calculate the remaining time
		function getTimeRemaining( endtimeRaw, countBy ) {

			// Some browsers need a "T" in there...

			var endtimeClean = endtimeRaw.replace(/\s/, 'T');
			if(browser.indexOf('firefox') > -1) endtimeClean = endtimeClean+"Z";
			var endtime = new Date( endtimeClean );

			// Eastern Time Offset
			var offset = -5.0;
			var clientDate = new Date();
			var utc = clientDate.getTime();
			var current = new Date( utc + ( 3600000 * offset ) );

			var t = Date.parse( endtime ) - Date.parse( current );
			var seconds = Math.floor( ( t / 1000 ) % 60 );
			var minutes = Math.floor( ( t / 1000 / 60 ) % 60 );
			var hours = Math.floor( ( t / ( 1000 * 60 * 60 ) ) % 24 );
			var days = Math.floor( t /( 1000 * 60 * 60 * 24 ) );

			if ( countBy === 'hour' ) {
				days = 0;
				hours = Math.floor( t / ( 1000 * 60 * 60 ) );
			}

			// Build out the JSON object
			return {
				'total': t,
				'days': days,
				'hours': hours,
				'minutes': minutes,
				'seconds': seconds
			};

		} // getTimeRemaining()

		// Update the DOM with the new time
		function updateClock( clock, endtime ) {

			var expirationAction = clock.querySelector( '.sidebar-timer__wrap' ).getAttribute( 'data-expiration' );
			var countBy = clock.querySelector( '.sidebar-timer__wrap' ).getAttribute( 'data-showby' );
			var t = getTimeRemaining( endtime, countBy );
			var days = clock.querySelector( '.timer-days' );
			var hours = clock.querySelector( '.timer-hours' );
			var minutes = clock.querySelector( '.timer-minutes' );
			var seconds = clock.querySelector( '.timer-seconds' );

			// Adds a leading 0 to maintain spacing
			days.querySelector('.sidebar-timer__value').innerHTML = ( '0' + t.days ).slice( -2 );
			if ( t.hours <= 99 ) {
				hours.querySelector('.sidebar-timer__value').innerHTML = ( '0' + t.hours ).slice( -2 );
			} else {
				hours.querySelector('.sidebar-timer__value').innerHTML = ( t.hours );
				clock.querySelector( '.sidebar-timer' ).classList.add( 'is-hourly-wide' );
			}
			minutes.querySelector('.sidebar-timer__value').innerHTML = ( '0' + t.minutes ).slice( -2 );
			seconds.querySelector('.sidebar-timer__value').innerHTML = ( '0' + t.seconds ).slice( -2 );

			if ( t.days === '0' ) {
				clock.querySelector( '.sidebar-timer' ).classList.add( 'is-hourly' );
			}

			if ( t.total <= 0 ) {

				// Stop the timer
				clearInterval( timeinterval );

				// This likely won't display in the UI, but let's set it anyway.
				days.querySelector('.sidebar-timer__value').innerHTML = 0;
				hours.querySelector('.sidebar-timer__value').innerHTML = 0;
				minutes.querySelector('.sidebar-timer__value').innerHTML = 0;
				seconds.querySelector('.sidebar-timer__value').innerHTML = 0;

				// The timer has expired, so hide it
				clock.querySelector( '.sidebar-timer__wrap' ).classList.add( 'is-removed' );
				clock.querySelector( '.sidebar-timer__wrap' ).classList.remove( 'is-active' );

				// If we should be displaying the message upon expiration, do so now
				if( expirationAction ===  'display-message' ) {

					clock.querySelector( '.sidebar-message' ).classList.remove( 'is-removed' );
					clock.querySelector( '.sidebar-message' ).classList.remove( 'is-active' );

				} else if ( expirationAction ===  'hide-component' ) {

					clock.classList.add( 'is-removed' );

				} // if

			} // if

		} // updateClock()

	} // constructor()

} // Sidebar {}

export default Sidebar;


// WEBPACK FOOTER //
// ./assets/components/sidebar/sidebar.js